// Text-case helpers — mirrors backend `services/text_utils.py`.
// Only auto-capitalises input that is entirely lowercase or entirely
// uppercase, so we don't mangle correctly typed names like "McDonald".

const ACRONYMS = new Set([
  'NHS', 'GP', 'GPS', 'CAMHS', 'ICO', 'UK', 'EU', 'GDPR', 'DPA',
  'CIC', 'CICS', 'MASH', 'LADO', 'PEP', 'EHCP', 'SEN', 'SENCO',
  'CCG', 'ADHD', 'ASD', 'PTSD', 'OCD', 'AA', 'OFSTED',
]);

const LOWERCASE_JOINERS = new Set([
  'of', 'and', 'the', 'for', 'in', 'on', 'at', 'to', 'de', 'la',
]);

function smartTitle(value) {
  if (!value) return value;
  const words = value.split(/\s+/);
  return words
    .map((word, i) => {
      const upper = word.toUpperCase();
      if (ACRONYMS.has(upper)) return upper;
      const titled = word
        .split('-')
        .map((part) =>
          part
            .split("'")
            .map((p) => (p ? p.charAt(0).toUpperCase() + p.slice(1).toLowerCase() : p))
            .join("'"),
        )
        .join('-');
      if (i > 0 && LOWERCASE_JOINERS.has(titled.toLowerCase())) {
        return titled.toLowerCase();
      }
      return titled;
    })
    .join(' ');
}

export function normaliseName(value) {
  if (value === null || value === undefined) return value;
  const s = String(value).trim();
  if (!s) return s;
  const hasLetter = /[a-zA-Z]/.test(s);
  if (!hasLetter) return s;
  // Per-word casing check: every space-separated token must itself be
  // entirely lowercase or entirely uppercase (tokens with no letters skip)
  const tokens = s.split(/\s+/);
  for (const tok of tokens) {
    if (!/[a-zA-Z]/.test(tok)) continue;
    if (tok !== tok.toLowerCase() && tok !== tok.toUpperCase()) {
      return s;
    }
  }
  return smartTitle(s);
}
